// import { Typography } from '@material-ui/core'

import SelectField from '../SelectField'
import EmailField from '../EmailField'
import DocumentNumberField from '../DocumentNumberField'
import NameField from '../NameField'
import Autocomplete from '../Autocomplete'

import { reactSwitch } from '../../../utils/utils'

const FormField = ({
   type,
   value,
   name,
   error,
   onChange,
   className = '',
   inputClassName,
   ...otherProps
}) => {
   const inputProps = {
      className: inputClassName,
      formValue: value,
      fieldName: name,
      handleChange: onChange,
      fieldInvalid: Boolean(error),
      error,
      ...otherProps
   }

   return (
      <div className={className}>
         {reactSwitch(type, {
            select: <SelectField {...inputProps} />,
            idNumber: <DocumentNumberField {...inputProps} />,
            email: <EmailField {...inputProps} />,
            autocomplete: <Autocomplete {...inputProps} />,
            default: <NameField {...inputProps} />
         })}
         {/* {error && (
                <Typography color="error" variant="caption">
                    {error}
                </Typography>
            )} */}
      </div>
   )
}

export default FormField
